import Vapi from '@vapi-ai/web';

export const VAPI_PUBLIC_KEY = 'd4bd4c09-4bd5-4daf-bf2a-16154152c17d';
export const VAPI_ASSISTANT_ID = '85d5f8d7-e20e-445c-8831-f565d74f41fe';

let vapiInstance = null;
let isCallingGlobal = false;
const listeners = new Set();

const setCallingState = (calling) => {
  isCallingGlobal = calling;
  listeners.forEach((cb) => {
    try {
      cb(calling);
    } catch (e) {
      console.error('Error in Vapi listener:', e);
    }
  });
};

export const getVapiInstance = () => {
  if (process.env.NODE_ENV === 'test') {
    return {
      start: () => Promise.resolve(),
      stop: () => {},
      on: () => {},
      off: () => {}
    };
  }

  if (!vapiInstance && typeof window !== 'undefined') {
    try {
      vapiInstance = new Vapi(VAPI_PUBLIC_KEY);

      vapiInstance.on('call-start', () => setCallingState(true));
      vapiInstance.on('call-end', () => setCallingState(false));
      vapiInstance.on('error', (err) => {
        console.error('Vapi Voice Error:', err);
        setCallingState(false);
      });
    } catch (err) {
      console.error('Vapi Initialization Error:', err);
    }
  }
  return vapiInstance;
};

export const isVapiCalling = () => isCallingGlobal;

export const toggleVapiCall = () => {
  if (process.env.NODE_ENV === 'test') {
    setCallingState(!isCallingGlobal);
    return;
  }

  const instance = getVapiInstance();
  if (isCallingGlobal) {
    if (instance && typeof instance.stop === 'function') {
      try {
        instance.stop();
      } catch (e) {
        console.error('Error stopping Vapi call:', e);
      }
    }
    setCallingState(false);
  } else {
    if (instance && typeof instance.start === 'function') {
      try {
        instance.start(VAPI_ASSISTANT_ID);
      } catch (e) {
        console.error('Error starting Vapi call:', e);
      }
    }
    setCallingState(true);
  }
};

export const subscribeVapiCall = (callback) => {
  listeners.add(callback);
  callback(isCallingGlobal);
  getVapiInstance();
  return () => {
    listeners.delete(callback);
  };
};

export const resetVapiStateForTest = () => {
  isCallingGlobal = false;
  listeners.clear();
};

